



















































































































































































import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import CardTitle from '@/components/common/CardTitle.vue';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { REQUIRED } from '@/rules';
import _ from 'lodash';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import {
    ResourceList,
    ChoiceList,
    ChoiceListItem,
    ListType,
    ViewpointList,
    FactorList,
} from '@/api/model/ResourceList';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Modelling from '@/store/modules/Modelling';
import { FactorGroup, FactorResource } from '@/api/model/FactorResource';
import FactorListInputDialog from '@/components/Lists/FactorListInputDialog.vue';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceModule = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling);

@Component({
    components: {
        FactorListInputDialog,
        CardTitle
    },
})
export default class FactorListSelection extends Vue {
    private REQUIRED = REQUIRED;
    private showLists = true;
    private displayFactors = [];
    private generating = false;
    private type: any = { FACTOR: 'FACTOR' };
    private loading = false;
    private listId: string = '';
    private alert = false;
    private alertText = 'Create';
    private alertType = 'success';
    private show: boolean = false;
    private selectedItem = {};
    private selectedLists =[];
    $refs!: {
        form: HTMLFormElement;
    };

    mounted() {}

    get storedLists() {
        return _.values(decisionsModule.decisionLists).filter(
            (list: any) => list.type === 'FACTOR'
        );
    }

    get activeFactorLists(){
        return workspaceModule.activeFactorLists;
    }
    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get previouslyCreatedLists() {
        if (this.selectedDecision)
            return VIEWPOINT_API.getDecisionLists(this.selectedDecision.decisionId);
    }

    get choices() {
        return choicesModule.choices;
    }

    get lists() {
        return this.storedLists;
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || [];
    }

    get viewpointsList() {
        return _.sortBy(viewpointsModule.decisionViewpoints || [], 'name');
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    @Watch('show')
    onShowChange() {
        if(this.show) {
            this.setSelectedLists();
            //Init lists from workspace options
        } else {
            // this.$refs.form.reset();
        }
        // this.refreshLists()
    }
    @Watch('storedLists')
    @Watch('activeFactorLists')
    private onListChange(){
        this.setSelectedLists();
    }

    private async submit() {
        let submitLists: string[] = this.storedLists!.filter(
            (list: FactorList, index) => this.selectedLists[index]
        ).map((list: any) => list.listId);
        if (submitLists) {
           await workspaceModule.updateSavedFactorLists(submitLists);
        } else{
           await workspaceModule.updateSavedFactorLists([]);
        };
        this.show = false;
    }
    
    private setSelectedLists() {
        this.selectedLists =  this.storedLists && this.activeFactorLists
            ? this.storedLists.map((list: any) =>
                  workspaceModule.activeFactorLists.includes(list.listId)
              )
            : [];
    }
    private async clearSelections() {
        this.selectedLists = [];
    }

    // private async refreshLists() {
    //     if(this.showLists && this.selectedDecision) {
    //         this.loading = true;
    //         this.storedLists = await VIEWPOINT_API.getDecisionLists(this.selectedDecision.decisionId);
    //         this.storedLists = this.storedLists.filter((list: ResourceList) => list.type === 'FACTOR')
    //         this.selectedLists = (this.storedLists) ? (this.storedLists.map((list: any) => workspaceModule.activeFactorLists.includes(list.listId))) : []

    //         this.loading = false;
    //     }
    // }

    private cancel() {
        this.listId = '';
        this.show = false;
        // this.$refs.form.reset();
    }

    private clear() {
        this.listId = '';
    }

    private createAlert() {
        setTimeout(() => {
            this.alert = false;
        }, 4000);
    }

    private isTableFactor(factor: FactorResource) {
        if(!factor){
            return false;
        }
        let allFactors = Object.values(this.factorResources);
        let tableFactors = allFactors.filter(
            (f: any) => f.groupTypeDefinition && f.groupTypeDefinition.type.includes('TABLE') && !f.groupTypeDefinition.type.includes("TABLE_GROWING")
        );
        if (tableFactors.filter((f: any) => f.childrenIds.includes(factor.id)).length > 0)
            return true;
        
        return (
            (factor as FactorGroup).groupTypeDefinition &&
            ((factor as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN' ||
                (factor as FactorGroup).groupTypeDefinition.type === 'TABLE_ROW')
        );
    }

    @Watch('selectedLists')
    onChangeSelectedLists() {
        this.displayFactors = this.storedLists.filter(
            (list: FactorList, index) => this.selectedLists[index]
        );
    }
}
